import React, { useEffect } from 'react';
import { Button } from '@hangar/web-components/core/Button';
import { useAssets } from '../../hooks/utils';
import { useDocumentHeadTitle } from '../../hooks/utils/useDocumentHeadTitle';
import { LATAM_CARGO_PUBLIC_PAGE_TITLES } from '../../utils/documentHeadTitle';
import * as S from './FeedbackThankYouPage.styles';
import { useTranslation } from '../../hooks/i18n';

const LATAMCARGO_URL = 'https://www.latamcargo.com';
// Clapping hands / celebratory illustration - replace with final asset when available
const FEEDBACK_THANK_YOU_ICON =
  'https://image.mails.latam.com/lib/fe3111717d64047b741c71/m/1/544a9c48-e6df-4d45-bfc0-97dd201dbfe2.png';

export const FeedbackThankYouPage: React.FC = () => {
  const { assets } = useAssets();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage('en');
  }, []);

  useDocumentHeadTitle(LATAM_CARGO_PUBLIC_PAGE_TITLES.feedbackSubmitted);

  return (
    <S.Container>
      <S.LogoContainer>
        <S.Logo src={assets.logos.latamCargo} alt="LATAM CARGO" />
      </S.LogoContainer>
      <S.Card>
        <S.IconWrapper>
          <img src={FEEDBACK_THANK_YOU_ICON} alt="" role="presentation" />
        </S.IconWrapper>
        <S.Title>{t('feedback.thankYouTitle')}</S.Title>
        <S.SubMessage>{t('feedback.thankYouSubMessage')}</S.SubMessage>
        <S.ButtonWrapper>
          <Button
            label={t('feedback.gotoLatamCargo')}
            variant="primary"
            onClick={() => window.open(LATAMCARGO_URL, '_blank', 'noopener,noreferrer')}
            data-testid="feedback-goto-latamcargo"
          />
        </S.ButtonWrapper>
      </S.Card>
    </S.Container>
  );
};
